import {GroupLimitInfo} from "./create/Dialog";
import {AVAILABLE_GROUP_SIZES} from "./types";
import {QuotaSelectorItem} from "../QuotaItemSelector";
import {
    CallGroupLimitForAllSizesQuery,
    CallGroupLimitForAllSizesQueryResult,
    useCallGroupLimitForAllSizesQuery,
} from "./queries.generated";
import {domainAllocationToQuotaInfo, QuotaInfo} from "../EndpointCreateDialog";

type Options = Parameters<typeof useCallGroupLimitForAllSizesQuery>[0];

export type CallGroupLimitsQueryHookResult = Omit<CallGroupLimitForAllSizesQueryResult, "data"> & {
    data?: GroupLimitInfo;
};

type EndpointLimitKey = Exclude<keyof CallGroupLimitForAllSizesQuery["domainAllocation"]["services"], "__typename">;

const mapCallGroupLimits = (
    data: CallGroupLimitForAllSizesQuery["domainAllocation"]["services"] | undefined,
): GroupLimitInfo => {
    if (!data) return undefined;

    const limits: GroupLimitInfo = {} as GroupLimitInfo;

    for (const size of AVAILABLE_GROUP_SIZES) {
        const key = `group${size}` as EndpointLimitKey;
        const limitInfo = data[key];

        if (!limitInfo) {
            throw new Error(`Call group limit for size ${size} not found in the response`);
        }

        limits[size] = domainAllocationToQuotaInfo(limitInfo);
    }

    return limits;
};

export function useCallGroupLimitsQuery(options: Options) {
    const query = useCallGroupLimitForAllSizesQuery(options);

    return {
        ...query,
        data: mapCallGroupLimits(query.data?.domainAllocation.services),
    };
}

export const limitInfoToQuotaItem = <Value extends string | number>(
    value: Value,
    limitInfo: QuotaInfo,
): QuotaSelectorItem<Value> => {
    return {
        value,
        ...limitInfo,
    };
};
